import classNames from 'class-names';
import PropTypes from 'prop-types';
import React, { forwardRef } from 'react';

import styles from './switch.module.css';

const Switch = forwardRef(
  (
    {
      name,
      variant = 'success',
      stateLabel = { checked: 'on', unchecked: 'off' },
      ...props
    },
    ref,
  ) => {
    const { disabled = false, checked = false } = props;

    return (
      <label
        ref={ref}
        htmlFor={name}
        className={classNames(
          'd-inline-flex mb-0',
          styles.label,
          checked && variant && `bg-${variant}`,
          !checked && `bg-gray`,
        )}
        style={{ [disabled && 'opacity']: '0.5' }}
        data-testid="switchLabel"
      >
        <input
          id={name}
          className={styles.checkbox}
          type="checkbox"
          disabled={disabled}
          checked={checked}
          {...props}
        />

        <span className={styles.button} />

        {stateLabel && (
          <div
            data-testid="switchLabelText"
            className={classNames(
              'd-flex text-uppercase text-white',
              styles.labelTxt,
              checked ? 'ml-3 pl-2 pr-5' : 'ml-3 pl-5 pr-2',
              `justify-content-${checked ? 'start' : 'end'}`,
            )}
          >
            {checked ? stateLabel.checked : stateLabel.unchecked}
          </div>
        )}
      </label>
    );
  },
);

Switch.propTypes = {
  name: PropTypes.string.isRequired,
  variant: PropTypes.string,
  stateLabel: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.shape({
      checked: PropTypes.string,
      unchecked: PropTypes.string,
    }),
  ]),
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
};

export default Switch;
